// extracted by mini-css-extract-plugin
export default {"full":"Songs_full__4dRiD","content":"Songs_content__PQVvG"};